export default "__VITE_ASSET__JENa87P8__";